import { useEffect } from 'react'
import { CloseIcon } from '@velasca/icons/close'
import type { AlgoliaPanelProps } from '@velasca/types'
import { Drawer } from '@velasca/ui/drawer'
import { trackEvent } from '@velasca/utils/track-event'
import { useAlgoliaFilters } from './AlgoliaSearchProvider'
import { Facets } from './Facets'
import { Close } from './styles'

export const FacetsDrawer = ({ panels }: AlgoliaPanelProps) => {
  const { isMenuOpen, setIsMenuOpen } = useAlgoliaFilters()

  useEffect(() => {
    if (isMenuOpen) {
      trackEvent({
        googleAnalytics: {
          eventName: 'filters_opened',
          data: { handle: 'mobile-drawer' },
        },
      })
    }
  }, [isMenuOpen])

  return (
    <Drawer
      isOpen={isMenuOpen}
      placement="left"
      close={() => {
        setIsMenuOpen(false)
      }}
    >
      <>
        <Facets panels={panels} />
        <Close
          onClick={() => {
            setIsMenuOpen(false)
          }}
        >
          <CloseIcon width="20" height="20" />
        </Close>
      </>
    </Drawer>
  )
}
